webpackJsonp([25],{

/***/ 585:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(12);

__webpack_require__(585);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactStatic.withRouteData)(function (props) {
  var content = props.story.content;


  return _react2.default.createElement(
    'div',
    { className: 'page__wrapper' },
    _react2.default.createElement(
      'h1',
      null,
      content.title || 'Coming Soon'
    ),
    _react2.default.createElement(
      'h2',
      null,
      content.subtitle || 'The website is currently under construction'
    )
  );
});

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/ComingSoon.16ac899c.js